// Spanish translations for Bucara Burger — natural, culturally appropriate for Latino audiences
const es = {
  // Navbar
  nav_home: 'Inicio',
  nav_about: 'Nosotros',
  nav_menu: 'Menú',
  nav_gallery: 'Galería',
  nav_location: 'Ubicación',
  nav_order_whatsapp: 'Pedir por WhatsApp',

  // Language switcher
  lang_en: 'EN',
  lang_es: 'ES',

  // Common buttons
  btn_order_whatsapp: 'Pedir por WhatsApp',
  btn_call_now: 'Llamar Ahora',
  btn_view_menu: 'Ver Menú',
  btn_view_full_menu: 'Ver Menú Completo',
  btn_view_full_gallery: 'Ver Galería Completa',
  btn_follow_instagram: 'Seguir en Instagram',
  btn_chat_whatsapp: 'Escríbenos por WhatsApp',
  btn_get_directions: 'Cómo Llegar',
  btn_open_maps: 'Abrir en Google Maps',
  map_find_us: 'Encuéntranos Aquí',
  map_open_maps_short: 'Abrir en Mapa',
  map_directions_title: 'Usa el mapa para llegar',
  map_directions_sub: 'Estamos en 1630 Broadway Ave, Boise, Idaho 83706. Toca "Abrir en Mapa" para obtener indicaciones paso a paso desde tu ubicación.',
  btn_message_whatsapp: 'Escribir por WhatsApp',

  // Hero Section
  hero_badge: 'Food Truck Colombiano · Boise, Idaho',
  hero_headline_1: 'DE BUCARAMANGA-COLOMBIA',
  hero_headline_2: 'A BOISE',
  hero_headline_3: 'CON AMOR',
  hero_sub: 'Hamburguesas gourmet, perros calientes al estilo bumangués, una propuesta de comida rápida latina y refrescantes bebidas tropicales, todo preparado al momento con auténtica pasión colombiana.',
  hero_highlight_1: 'Preparado al Momento',
  hero_highlight_2: 'Boise, Idaho',
  hero_highlight_3: 'Sabor Colombiano Auténtico',
  hero_highlight_4: 'Servicio Rápido y Amable',
  hero_highlight_5: 'Pedidos por WhatsApp',

  // About Section (Home)
  about_eyebrow: 'Nuestra Historia',
  about_headline_1: 'Llevando el sabor auténtico de',
  about_headline_2: 'Bucaramanga',
  about_headline_3: 'a Idaho',
  about_p1: 'Bucara Burger nació de un sueño — dos jóvenes emprendedores colombianos que lo dejaron todo para traer los sabores auténticos y vibrantes de Colombia al corazón de Boise, Idaho. Lo que comenzó como un proyecto de pasión impulsado por noches largas, recetas familiares y una fe inquebrantable en su comida, rápidamente se convirtió en algo mucho más grande.',
  about_p2: 'Inspirados en la vibrante cultura gastronómica de Bucaramanga — la capital culinaria de Colombia — creamos un menú que honra la tradición mientras abraza la energía de la comida latina moderna. Cada hamburguesa, cada perro caliente, cada arepa está hecha con el mismo amor y dedicación que trajimos desde casa.',
  about_p3: 'Hoy, Bucara Burger es más que un food truck. Es una comunidad, una cultura y un pedacito de Colombia aquí en Idaho. Nos enorgullece servir a Boise, Meridian, Nampa y más allá — una deliciosa mordida a la vez.',
  about_stat_1: '100% Recetas Colombianas',
  about_stat_2: 'El Food Truck Favorito de Boise',
  about_feat_1_title: 'Hecho con Pasión',
  about_feat_1_sub: 'En cada pedido',
  about_feat_2_title: 'Ingredientes Frescos',
  about_feat_2_sub: 'Sin atajos, nunca',
  about_feat_3_title: 'Orgullosamente Local',
  about_feat_3_sub: 'Boise, Idaho',

  // Menu Section (Home)
  menu_eyebrow: 'Lo Que Servimos',
  menu_headline: 'Nuestro',
  menu_headline_accent: 'Menú',
  menu_sub: 'Todo preparado al momento con recetas colombianas auténticas y los mejores ingredientes.',

  // Gallery Section (Home)
  gallery_eyebrow: 'Directo del Truck',
  gallery_headline: 'Nuestra',
  gallery_headline_accent: 'Galería',
  gallery_sub: 'Un festín visual — comida real, gente real, pasión colombiana de verdad.',

  // Location Section (Home)
  location_eyebrow: 'Encuéntranos',
  location_headline: 'Ubicación y',
  location_headline_accent: 'Contacto',
  location_sub: 'Visítanos en Boise, Idaho — o escríbenos por WhatsApp para hacer tu pedido.',
  location_business_name: 'Bucara Burger',
  location_business_sub: 'Food Truck Colombiano · Boise, Idaho',
  location_address_label: 'Dirección',
  location_phone_label: 'Teléfono',
  location_hours_label: 'Horario de Atención',
  location_follow_label: 'Síguenos',
  location_cta_title: '¿Tienes Hambre? Estamos Listos.',
  location_cta_sub: 'Haz tu pedido por WhatsApp y lo tenemos listo fresquito para ti.',
  location_cta_btn: 'Escríbenos por WhatsApp →',
  location_today: 'Hoy',
  location_closed: 'Cerrado',
  day_monday: 'Lunes',
  day_tuesday: 'Martes',
  day_wednesday: 'Miércoles',
  day_thursday: 'Jueves',
  day_friday: 'Viernes',
  day_saturday: 'Sábado',
  day_sunday: 'Domingo',

  // Footer
  footer_tagline: 'Sabores colombianos auténticos en el corazón de Boise, Idaho. Hecho fresco, hecho con amor.',
  footer_nav_title: 'Navegación',
  footer_social_title: 'Síguenos',
  footer_contact_title: 'Contacto',
  footer_whatsapp_order: 'Pedido por WhatsApp',
  footer_copyright: '© {year} Bucara Burger. Todos los derechos reservados. Food Truck Colombiano · Boise, Idaho.',
  footer_serving: 'Servimos en Boise · Meridian · Nampa · Caldwell · Eagle · Kuna · Middleton · Star',
  footer_about: 'Nosotros',

  // About Page
  about_page_badge: 'Nuestra Historia · Boise, Idaho',
  about_page_title: 'Sobre',
  about_page_title_accent: 'Bucara',
  about_page_title_2: 'Burger',
  about_page_sub: 'Un food truck colombiano que trae sabor auténtico, pasión y personalidad a Boise — una hamburguesa a la vez.',
  about_story_label: 'Nuestra Historia',
  about_badge_colombian: 'Colombiano',
  about_story_title: 'Nacido de un',
  about_story_title_accent: 'Sueño Colombiano',
  about_story_p1: 'Bucara Burger nació del sueño de dos jóvenes emprendedores colombianos apasionados por la gastronomía y con el deseo de compartir los sabores auténticos de su tierra en los Estados Unidos.',
  about_story_p2: 'Lo que comenzó como una pequeña idea construida con dedicación y pasión se convirtió en un concepto de food truck con identidad fuerte, calidad y carácter. Bucara Burger combina ingredientes frescos, recetas originales y un estilo urbano único que conecta con sus raíces.',
  about_story_p3: 'Hoy, la marca representa más que comida — representa esfuerzo, disciplina y el orgullo de llevar un pedacito de Colombia a cada cliente en Boise. Como el food truck colombiano de referencia en Boise, servimos sabor colombiano auténtico en Idaho con cada pedido.',
  about_stat_label_1: 'Recetas Colombianas',
  about_stat_label_2: 'Preparado al Momento',
  about_stat_label_3: 'Con Base en Idaho',
  about_stat_label_4: 'Hecho con Pasión',
  about_why_eyebrow: 'Lo Que Nos Diferencia',
  about_why_title: '¿Por qué',
  about_why_title_accent: 'Bucara Burger?',
  about_why_sub: 'Cuatro razones por las que somos el food truck colombiano favorito de Boise.',
  about_why_1_title: 'Sabor Colombiano Auténtico',
  about_why_1_desc: 'Cada receta tiene raíces en la tradición culinaria colombiana. Traemos el verdadero sabor de Colombia a los amantes de la comida latina en Boise — sin atajos ni compromisos.',
  about_why_2_title: 'Ingredientes Frescos al Momento',
  about_why_2_desc: 'Nunca precocinamos ni recalentamos. Cada hamburguesa, perro caliente y plato se prepara fresco en el momento de tu pedido — porque la calidad no es negociable.',
  about_why_3_title: 'Servicio Rápido y Amable',
  about_why_3_desc: 'Tratamos a cada cliente como familia. Rápido, cálido y personal — la experiencia Bucara Burger es tan buena como la comida misma.',
  about_why_4_title: 'Food Truck Urbano con Identidad Latina',
  about_why_4_desc: 'No somos solo un food truck — somos una experiencia cultural. Branding audaz, energía latina y un ambiente que hace cada visita memorable.',
  about_exp_eyebrow: 'Lo Que Ofrecemos',
  about_exp_title: 'Nuestra',
  about_exp_title_accent: 'Experiencia',
  about_exp_sub: 'Desde hamburguesas gourmet hasta bebidas colombianas — todo lo que servimos está hecho con pasión y orgullo colombiano.',
  about_exp_1_title: 'Hamburguesas Gourmet',
  about_exp_1_desc: 'Elaboradas con carne premium, panes brioche artesanales y toppings de inspiración colombiana. Cada hamburguesa es una obra maestra para los amantes del sabor en Boise y más allá.',
  about_exp_1_tag: 'Firma',
  about_exp_2_title: 'Perros Calientes Colombianos',
  about_exp_2_desc: 'Nuestros perros calientes son un clásico de la calle colombiana — cargados con papas fritas, salsas y toppings que convierten un perro caliente en una experiencia inolvidable.',
  about_exp_2_tag: 'Favorito del Público',
  about_exp_3_title: 'Comida Rápida Latina',
  about_exp_3_desc: 'Desde papas fritas hasta snacks cargados, nuestro menú de comida rápida latina trae la energía de las esquinas colombianas directo a las calles de Boise, Idaho.',
  about_exp_3_tag: 'Estilo Callejero',
  about_exp_4_title: 'Bebidas Colombianas Refrescantes',
  about_exp_4_desc: 'Refréscate con bebidas tropicales colombianas — desde limonadas frescas hasta jugos tradicionales que combinan perfecto con cada bocado de nuestro menú.',
  about_exp_4_tag: 'Refrescante',
  about_exp_5_title: 'Servicio en el Truck',
  about_exp_5_desc: 'Encuéntranos en nuestros puntos habituales por Boise. Llega, pide fresco y disfruta en el momento. Sin esperas, sin complicaciones — pura energía de food truck colombiano.',
  about_exp_5_tag: 'Food Truck',
  about_exp_6_title: 'Catering Disponible',
  about_exp_6_desc: '¿Planeas un evento en Boise, Meridian o Nampa? Bucara Burger está disponible para eventos privados, catering corporativo y ocasiones especiales. Escríbenos por WhatsApp para reservar.',
  about_exp_6_tag: 'Eventos',
  about_cta_eyebrow: 'Ven a Encontrarnos',
  about_cta_title: '¿Listo para Probar',
  about_cta_title_accent: 'Bucara Burger?',
  about_cta_sub: 'Ven a vivir el sabor colombiano auténtico en Boise. Pide por WhatsApp, llámanos o explora nuestro menú completo — estamos listos para servirte algo inolvidable.',

  // Menu Page
  menu_page_badge: 'Food Truck Colombiano en Boise',
  menu_page_title: 'Nuestro',
  menu_page_title_accent: 'Menú',
  menu_page_intro: 'En Bucara Burger, cada pedido se prepara fresco con sabor intenso, ingredientes de calidad y ese toque colombiano que nos distingue. Desde hamburguesas gourmet hasta perros calientes colombianos auténticos — hay algo para todos.',
  menu_page_seo: 'Las mejores hamburguesas colombianas en Boise Idaho · Comida latina en Boise · Colombian food truck Idaho',
  menu_note: 'Todo preparado al momento. Los artículos del menú pueden variar según disponibilidad. Los precios están sujetos a cambios sin previo aviso. Contáctanos directamente por WhatsApp o teléfono para disponibilidad actual y pedidos especiales.',
  menu_note_bold: 'Todo preparado al momento.',
  menu_cta_eyebrow: '¿Listo para comer?',
  menu_cta_title: 'Pide Tu Sabor',
  menu_cta_title_2: 'Colombiano Favorito',
  menu_items_label: 'artículo',
  menu_items_label_plural: 'artículos',

  // Menu Category Labels
  cat_burgers: 'Hamburguesas',
  cat_hotdogs: 'Perros Calientes Colombianos',
  cat_latin_specials: 'Especialidades Bumanguesas',
  cat_kids: 'Menú Infantil',
  cat_empanadas: 'Empanadas y Papas Rellenas',
  cat_arepas: 'Arepas Rellenas',
  cat_juices: 'Jugos Naturales',
  cat_drinks: 'Bebidas',

  // Size options
  size_label: 'Tamaño',
  size_one_person: 'Para una persona',
  size_two_people: 'Para dos personas',

  // Menu Item Names & Descriptions
  item_bucara_classic_name: 'Hamburguesa Clásica Bucara',
  item_bucara_classic_desc: 'Carne de res jugosa, queso cheddar, cebollas caramelizadas, lechuga, tomate y nuestra salsa secreta Bucara en pan brioche.',
  item_doble_colombiana_name: 'Doble Colombiana',
  item_doble_colombiana_desc: 'Doble carne smash, doble queso, tocino crocante, jalapeños, piña y salsa rosada estilo colombiano. Intensa e inolvidable.',
  item_pollo_paisa_name: 'Hamburguesa Pollo Paisa',
  item_pollo_paisa_desc: 'Pechuga de pollo apanada y crocante, coleslaw, aguacate, cebollas encurtidas y mayonesa chipotle en pan de ajonjolí tostado.',
  item_bucara_bbq_name: 'Hamburguesa BBQ Bucara',
  item_bucara_bbq_desc: 'Carne ahumada bañada en salsa BBQ, aros de cebolla crocantes, tocino, cheddar y pepinillos en pan brioche tostado.',
  item_mushroom_swiss_name: 'Hamburguesa Champiñones y Suizo',
  item_mushroom_swiss_desc: 'Carne con champiñones salteados, queso suizo, aioli de ajo, rúcula y cebollas caramelizadas en pan pretzel.',
  item_nueva_burger_name: 'La Bumanguesa',
  item_nueva_burger_desc: 'Nuestra hamburguesa estilo Bucaramanga con chorizo desmenuzado, hogao, chicharrón crocante, aguacate y queso blanco en pan tostado.',
  item_perro_clasico_name: 'Perro Caliente Colombiano Clásico',
  item_perro_clasico_desc: 'Perro caliente de carne cargado con papitas, salsa de piña, salsa rosada, mostaza, kétchup y queso costeño. El auténtico.',
  item_perro_especial_name: 'Perro Caliente Especial Bucara',
  item_perro_especial_desc: 'Perro caliente jumbo, tiras de tocino, cebollas caramelizadas, jalapeño relish, todas nuestras salsas signature y una montaña de toppings.',
  item_perro_tropical_name: 'Perro Caliente Tropical',
  item_perro_tropical_desc: 'Perro caliente a la plancha con salsa de mango, crema de coco, coco tostado y un toque de limón. Un giro tropical colombiano.',
  item_perro_picante_name: 'Perro Caliente Picante',
  item_perro_picante_desc: 'Perro caliente picante con jalapeños, salsa habanero, chalotes crocantes, mayonesa sriracha y chips de tortilla triturados.',
  item_desgranado_name: 'Desgranado',
  item_desgranado_desc: 'Mazorca colombiana desgranada salteada con mantequilla, queso, mayonesa, limón y un toque de ají. El favorito de todos.',
  item_picada_name: 'Picada Colombiana',
  item_picada_desc: 'Una generosa bandeja compartida con chorizo a la plancha, chicharrón, papa criolla, morcilla y arepas. Perfecta para compartir.',
  item_patacon_name: 'Patacón Mixto',
  item_patacon_desc: 'Base de plátano verde frito dos veces, cargado con carne desmechada, pollo, hogao, aguacate y queso blanco desmenuzado.',
  item_kids_burger_name: 'Combo Infantil Hamburguesa',
  item_kids_burger_desc: 'Mini hamburguesa de res con queso, kétchup y toppings suaves. Servida con papas pequeñas y jugo. ¡A los niños les encanta!',
  item_kids_salchipapa_name: 'Combo Infantil Salchipapa',
  item_kids_salchipapa_desc: 'Salchicha de res en rodajas con papas fritas doradas y crocantes, kétchup y mayonesa. Un clásico colombiano que los niños adoran.',
  item_empanada_mixta_name: 'Empanada de Trigo Mixta',
  item_empanada_mixta_desc: 'Empanada de trigo crocante rellena de una deliciosa mezcla de carne de res y pollo sazonados, servida con ají para mojar.',
  item_empanada_pollo_name: 'Empanada de Trigo Pollo y Queso',
  item_empanada_pollo_desc: 'Empanada de trigo dorada rellena de pollo desmechado tierno y queso derretido. Crocante por fuera, cremosa por dentro.',
  item_empanada_yuca_name: 'Empanada de Yuca',
  item_empanada_yuca_desc: 'Empanada tradicional de yuca con masa crocante, rellena de carne molida sazonada y especias. Sin gluten.',
  item_arepa_carne_name: 'Arepa Rellena de Carne',
  item_arepa_carne_desc: 'Arepa de maíz gruesa a la plancha, rellena de carne de res desmechada jugosa, hogao y queso derretido. Un clásico colombiano.',
  item_arepa_pollo_name: 'Arepa Rellena de Pollo',
  item_arepa_pollo_desc: 'Arepa de maíz a la plancha rellena de pollo desmechado tierno, aguacate cremoso, hogao y queso blanco fresco.',
  item_arepa_nueva1_name: 'Arepa Rellena de Chicharrón',
  item_arepa_nueva1_desc: 'Arepa de maíz gruesa a la plancha cargada con chicharrón crocante, hogao, aguacate y un toque de ají. Un clásico bumangués.',
  item_arepa_nueva2_name: 'Arepa Rellena Mixta',
  item_arepa_nueva2_desc: 'Lo mejor de todo — carne desmechada, pollo, chicharrón, hogao, queso derretido y aguacate, todo dentro de una arepa gruesa a la plancha.',
  item_jugo_limonada_name: 'Limonada Natural',
  item_jugo_limonada_desc: 'Limonada colombiana recién exprimida con el equilibrio perfecto entre dulce y ácido. Hecha al momento con limones naturales.',
  item_jugo_guanabana_name: 'Jugo Natural de Guanábana',
  item_jugo_guanabana_desc: 'Jugo cremoso y exótico de guanábana, naturalmente dulce con un sabor tropical único de la cocina colombiana.',
  item_jugo_maracuya_name: 'Jugo Natural de Maracuyá',
  item_jugo_maracuya_desc: 'Vibrante jugo de maracuyá repleto de sabor tropical. Ácido, refrescante y 100% natural.',
  item_jugo_mora_name: 'Jugo Natural de Mora',
  item_jugo_mora_desc: 'Jugo de mora elaborado con moras colombianas frescas. Profundo, frutal y naturalmente dulce.',
  item_jugo_salpicon_name: 'Salpicón de Frutas',
  item_jugo_salpicon_desc: 'Un refrescante salpicón colombiano con frutas tropicales mixtas, jugo de sandía y un toque de soda. Colorido y delicioso.',
  item_soda_water_name: 'Gaseosa y Agua Embotellada',
  item_soda_water_desc: 'Gaseosas variadas (Coca-Cola, Sprite, Fanta, Diet Coke) y agua natural o con gas embotellada para complementar tu comida.',

  // Gallery Categories
  gallery_cat_burgers: 'Hamburguesas Destacadas',
  gallery_cat_burgers_sub: 'Hamburguesas colombianas gourmet elaboradas con sabores intensos e ingredientes premium',
  gallery_cat_hotdogs: 'Perros Calientes Colombianos',
  gallery_cat_hotdogs_sub: 'Auténticos perros calientes colombianos cargados de toppings y salsas signature',
  gallery_cat_fastfood: 'Comida Rápida Latina',
  gallery_cat_fastfood_sub: 'Empanadas, arepas, patacones y favoritos de la comida callejera colombiana',
  gallery_cat_truck: 'Experiencia Food Truck',
  gallery_cat_truck_sub: 'La energía, el ambiente y la cultura detrás de Bucara Burger en Boise',
  gallery_cat_atmosphere: 'Momentos y Ambiente',
  gallery_cat_atmosphere_sub: 'El alma, la identidad y el espíritu colombiano que hacen único a Bucara Burger',

  // Gallery Page
  gallery_page_badge: 'Food Truck en Boise · Comida Colombiana en Idaho',
  gallery_page_title: 'Nuestra',
  gallery_page_title_accent: 'Galería',
  gallery_page_sub: 'Un vistazo al sabor, estilo y experiencia de Bucara Burger',
  gallery_page_intro: 'Cada plato en Bucara Burger está hecho para destacar — desde la presentación hasta el sabor. Nuestra galería refleja la energía, frescura e identidad colombiana detrás de cada pedido.',
  gallery_cta_eyebrow: 'Hamburguesas y Comida Latina en Boise',
  gallery_cta_title: '¿Ves algo que',
  gallery_cta_title_accent: 'se te antoja?',
  gallery_section_1: 'Hamburguesas Signature',
  gallery_section_2: 'Perros Calientes Colombianos',
  gallery_section_3: 'Comida Rápida Latina',
  gallery_section_4: 'Experiencia en el Truck',
  gallery_section_5: 'Momentos de Marca / Ambiente',

  // Location Page
  location_page_badge: 'Food Truck Colombiano · Boise, Idaho',
  location_page_title: 'Ubicación y',
  location_page_title_accent: 'Contacto',
  location_page_sub: 'Visítanos en Boise o contáctanos directamente — siempre estamos listos para servirte sabor colombiano auténtico.',
  location_address_title: 'Dirección',
  location_phone_title: 'Teléfono',
  location_phone_tap: 'Toca para llamar directamente',
  location_wa_title: 'Escribir por WhatsApp',
  location_wa_sub: 'La forma más rápida de contactarnos · Respondemos rápido',
  location_hours_title: 'Horario de Atención',
  location_social_title: 'Síguenos',
  location_map_title: 'Encuéntranos en el Mapa',
  location_map_note: 'Usa el mapa para obtener indicaciones',
  location_quick_title: 'Contáctanos al Instante',
  location_quick_eyebrow: 'Acciones Rápidas',
  location_call_sub: 'Habla con nosotros directamente',
  location_wa_action_sub: 'La forma más rápida de pedir',
  location_menu_sub: 'Ver todos los artículos',
  location_area_badge: 'Treasure Valley, Idaho',
  location_area_title: 'Servimos Boise y Áreas Cercanas',
  location_area_text: 'Bucara Burger sirve con orgullo a <strong>Boise</strong> y las comunidades cercanas de Idaho que buscan sabor colombiano auténtico, hamburguesas gourmet, perros calientes y favoritos de food truck latino. Ya estés en <strong>Meridian</strong>, <strong>Nampa</strong>, <strong>Caldwell</strong> o en cualquier parte del Treasure Valley — somos tu opción de comida callejera colombiana en Idaho.',
  location_trust_1_title: 'Food Truck en Boise Idaho',
  location_trust_1_desc: 'Encuéntranos en 1630 Broadway Ave, Boise. La mejor comida callejera colombiana del Treasure Valley.',
  location_trust_2_title: 'Comida Callejera Colombiana en Idaho',
  location_trust_2_desc: 'Hamburguesas, perros calientes, empanadas, arepas y jugos naturales auténticos — preparados frescos con recetas colombianas.',
  location_trust_3_title: 'Comida Latina Cerca de Boise',
  location_trust_3_desc: 'Servimos el área metropolitana de Boise con sabores latinos intensos. Pide por WhatsApp o llámanos directamente.',

  // Admin Nav
  admin_nav_dashboard: 'Panel de Control',
  admin_nav_activity: 'Actividad',
  admin_nav_users: 'Usuarios',
  admin_nav_categories: 'Categorías',
  admin_nav_menu: 'Menú',
  admin_nav_gallery_categories: 'Categorías de Galería',
  admin_nav_gallery: 'Galería',
  admin_nav_business: 'Información del Negocio',
  admin_nav_logout: 'Cerrar Sesión',
};

export default es;
